const axios = require('axios')
const API_END_POINT = window._env.host.bhuntrApi
const LOGIN_URL = API_END_POINT + '/auth/login'
const FORGOT_PASSWORD = API_END_POINT + '/auth/forgotpassword'
const RESET_PASSWORD = API_END_POINT + '/auth/resetpassword'
const CHECK_AUTH = API_END_POINT + '/v2/account/renew'

import { generateResponse, generateErrorResponse } from './common'

export default {
  API_END_POINT: API_END_POINT,
  resetPassword (creds) {
    return axios({
      method: 'post',
      url: RESET_PASSWORD,
      data: creds
    }).then(generateResponse, generateErrorResponse)
  },
  forgotPasswordCheckToken (token) {
    return axios(FORGOT_PASSWORD + '?token=' + token)
      .then(generateResponse, generateErrorResponse)
  },
  forgotPassword (creds) {
    return axios({
      method: 'post',
      url: FORGOT_PASSWORD,
      data: creds
    }).then(generateResponse, generateErrorResponse)
  },
  check (token) {
    if (typeof token !== 'undefined' && token !== '') {
      return axios({
        method: 'get',
        url: CHECK_AUTH,
        headers: {
          Authorization: 'Bearer ' + token
        }
      }).then(generateResponse, generateErrorResponse)
    } else {
      return Promise.reject({
        status: 'err',
        messages: ''
      })
    }
  },
  login (creds) {
    return axios({
      method: 'post',
      url: LOGIN_URL,
      data: creds
    }).then(generateResponse, generateErrorResponse)
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js